import React, { Component } from "react";
import {
  ModalPattern,
  Regular,
  HelperText,
  H1,
  H3,
  InfoAlert,
  DollarAlert,
  LargePrimaryButton,
} from "@worthy-npm/clarity";
import PageHeader from "../pageHeader";
import LikeDislikeBanner from "../likeDislikeBanner";
import CalcControllers from "./calcControllers";
import ServicesSection from "../servicesSection";
import DIYSection from "../DIYSection";
import { isMobile, imageUrl, roundedPrice } from "helpers/ApplicationHelper";
import {
  BUYER_FEES_BASED_ON_VALUE_TIERS,
  VALUE_TIERS_MAX_THRESHOLD,
  PRICE_RANGE_VALUES,
} from "constants/calculator";
import WorthyApi from "lib/api/worthyApi";
import GA from "lib/ga";
import CalendlyHelper from "lib/calendly";
import { connect } from "react-redux";
const EVENTS_LABEL = "from Calculator page";

class Calculate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openCalcControllers: false,
      evaluation: "$-----",
      description: "Diamond",
      loading: false,
      closeModal: false,
      mobileDisableSend: true,
      diamondProperties: {},
    };

    this.isMobile = isMobile();
  }

  getPriceRange(price) {
    const tierValue = Object.values(VALUE_TIERS_MAX_THRESHOLD).filter((val) => {
      return price < val;
    })[0];
    const tier = Object.keys(VALUE_TIERS_MAX_THRESHOLD).find(
      (key) => VALUE_TIERS_MAX_THRESHOLD[key] === tierValue
    );
    const buyerFees = BUYER_FEES_BASED_ON_VALUE_TIERS[tier];
    const priceAfterBuyerFees = price * (1 - buyerFees);

    return `${roundedPrice(
      priceAfterBuyerFees * PRICE_RANGE_VALUES.low
    )} - ${roundedPrice(priceAfterBuyerFees * PRICE_RANGE_VALUES.high)}`;
  }

  updateValues(properties) {
    console.log(properties);
    this.setState({ diamondProperties: properties });
    const emptys = Object.values(properties).filter((val) => {
      return val === "";
    }).length;
    clearTimeout(this.request);
    if (emptys === 0 && properties.size !== "--") {
      setTimeout(() => {
        this.setState({ loading: true });
      }, 500);
      this.setState({ mobileDisableSend: false });
      this.request = setTimeout(() => {
        GA.expertsCalculatorSuccess();
        WorthyApi._wave("post", "v2/calculator/search", {
          asset: {
            type: "major_stones",
            properties: { ...properties },
          },
        })
          .then((res) => {
            const evaluation = this.getPriceRange(res.data.price);
            const description = `${properties.size} ct. ${properties.shape} cut, ${properties.color}, ${properties.clarity}`;
            this.setState({
              evaluation: evaluation,
              loading: false,
              description: description,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({ loading: false });
          });
      }, 1000);
    }
  }

  render() {
    return (
      <div className="calculate-item-value">
        <div className="calculator margin-0-auto d-flex flex-col">
          <div className="calculator-header">
            <PageHeader
              label={{ title: "Tool", color: "#E38E1F" }}
              title="Resale Price Range Calculator"
              diamondText="Based on attributes"
            />
            {this.isMobile ? null : (
              <Regular
                overrideWrapperCSS={{ marginTop: "50px" }}
                text="To calculate a resale price range, enter your diamond’s attributes below."
              />
            )}
          </div>
          <div className="calculator-content d-flex">
            {this.isMobile ? null : (
              <div
                className={`controllers-wrapper ${
                  this.state.loading ? "blur" : ""
                }`}
              >
                <CalcControllers
                  updateValue={(properties) => {
                    this.updateValues(properties);
                  }}
                />
              </div>
            )}
            <div className="calculator-output-container d-flex flex-col">
              {this.isMobile ? (
                <div className="calc-button d-flex flex-justify-center">
                  {this.state.description === "Diamond" ? (
                    <LargePrimaryButton
                      text="Calculate Diamond Value"
                      overrideCSS={{
                        width: "100%",
                        borderRadius: "2px",
                        fontSize: "16px",
                      }}
                      overrideWrapperCSS={{ width: "100%" }}
                      click={(stopAnimation) => {
                        stopAnimation();
                        this.setState({
                          openCalcControllers: true,
                          closeModal: false,
                        });
                      }}
                    />
                  ) : (
                    <div className="text-center w-100 d-flex flex-col">
                      <HelperText
                        overrideCSS={{
                          textalign: "center",
                          marginBottom: "15px",
                        }}
                        text="Diamond attributes"
                      />
                      <div className="edit-section d-flex flex-align-center">
                        <Regular text={this.state.description} />
                        <div
                          className="edit-icon-container d-flex flex-align-center"
                          onClick={() => {
                            this.setState({ openCalcControllers: true });
                          }}
                        >
                          <img
                            className="edit-img"
                            src={imageUrl("experts/calculator/edit.svg")}
                            alt="edit-icon"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
              <div className="calculator-output text-center w-100">
                <HelperText text="Calculator output" />
                <div className="calc-results d-flex flex-col flex-align-center">
                  {this.state.loading ? (
                    <div className="loader-container d-flex flex-align-center">
                      <img
                        className="loader-img"
                        src={imageUrl("experts/calculator/loader.gif")}
                        alt="loading"
                      />
                    </div>
                  ) : (
                    <div className="calc-results-text">
                      <HelperText
                        overrideCSS={{ marginTop: "20px" }}
                        text={this.state.description}
                      />
                      <H1
                        overrideCSS={{
                          font: `700 ${
                            this.isMobile ? 30 : 42
                          }px / 44px "Open Sans"`,
                        }}
                        text={this.state.evaluation}
                      />
                    </div>
                  )}
                  <InfoAlert
                    overrideCSS={{ textAlign: "left", fontSize: "16px" }}
                    overrideWrapperCSS={{
                      width: "100%",
                      margin: "25px 0 15px",
                    }}
                    canClose={false}
                    text="Price range is based on past diamond sales in the secondary diamond market."
                  />
                  <DollarAlert
                    overrideCSS={{ textAlign: "left", fontSize: "16px" }}
                    overrideWrapperCSS={{ width: "100%" }}
                    canClose={false}
                    TextComponent={() => {
                      return (
                        <span>
                          <a
                            className="dollar-alert-link"
                            onClick={() => {
                              CalendlyHelper.showPopupWidget("from Calc alert");
                            }}
                          >
                            {" "}
                            Book a consultation
                          </a>{" "}
                          with a selling expert for an accurate price range for
                          your jewelry.
                        </span>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <LikeDislikeBanner
            question="Was this content helpful?"
            closingText="Thank you for your feedback!"
            eventsLabel="from Calculator page"
          />
        </div>
        <DIYSection
          eventsLabel={EVENTS_LABEL}
          data={["HOW_TO_PRICE"]}
          recomended={true}
        />
        <div className="cards-container">
          <ServicesSection
            pageName="Calculaor"
            lastItem={this.props.LastItem}
          />
        </div>
        {this.state.openCalcControllers ? (
          <ModalPattern
            key={"ModalPattern"}
            textAlign={"center"}
            closeIcon={true}
            closeOnClickOutside={true}
            isWide={true}
            closeNow={this.state.closeModal}
            closeOnEscape={false}
            overrideCSS={{ overflow: "scroll" }}
            onClose={() => {
              this.setState({ openCalcControllers: false });
            }}
          >
            <H3 text="Diamond Attributes" />
            <Regular
              overrideWrapperCSS={{ padding: "0 20px" }}
              text="To calculate a resale price range, enter your diamond’s attributes below."
            />
            <CalcControllers
              updateValue={(properties) => {
                this.updateValues(properties);
              }}
              size={this.state.diamondProperties.size}
              shape={this.state.diamondProperties.shape}
              color={this.state.diamondProperties.color}
              clarity={this.state.diamondProperties.clarity}
            />
            <LargePrimaryButton
              text={
                this.state.description !== "Diamond" &&
                this.state.buttonTextUpdate
                  ? "Update"
                  : "Enter Calculation"
              }
              disabled={this.state.mobileDisableSend}
              overrideCSS={{ width: "100%", borderRadius: "2px" }}
              overrideWrapperCSS={{
                width: "100%",
                padding: "0 20px",
                boxSizing: "border-box",
              }}
              click={(stopAnimation) => {
                stopAnimation();
                this.setState({ closeModal: true });
                setTimeout(() => {
                  this.setState({ closeModal: false, buttonTextUpdate: true });
                }, 1000);
              }}
            />
          </ModalPattern>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({ LastItem }) => {
  return {
    LastItem,
  };
};

export default connect(mapStateToProps)(Calculate);
